// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1MqLh","header":"MessagesList_header__109Xw","chat":"MessagesList_chat__3Jrpy"};